import axios from 'axios';
import { createMerchandiseQuery } from './queries';

const addMerchandise = async (model) => {
    try {
        const query = createMerchandiseQuery({ model });
        const request = axios.post(query.url, { ...query.body });
        const { data } = await request;
        return { data };
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        throw new Error('Unable to add product');
    }
};

export default addMerchandise;
